import type { CSSProperties } from 'react';

export const CHART_SUCCESS = '#0f965e';
export const CHART_SUCCESS_LIGHT = '#70cfa5';
export const CHART_SUCCESS_TEXT = '#0b6842';
export const CHART_ERROR = '#e85353';
export const CHART_ERROR_DARK = '#b33131';
export const CHART_WARNING = '#c9832a';
export const CHART_ORANGE = '#d15f24';
export const CHART_NEUTRAL = '#6b8295';

export const CHART_CATEGORICAL = [
  '#1489c9',
  '#0e7490',
  '#6657d9',
  '#0f766e',
  '#c9832a',
  '#be4d79',
  '#6b8295',
] as const;

export const CHART_PROVIDER_COLORS = {
  fal: CHART_CATEGORICAL[0],
  gemini: CHART_CATEGORICAL[3],
} as const;

export const CHART_TIER_COLORS = [
  CHART_CATEGORICAL[5],
  CHART_CATEGORICAL[1],
  CHART_CATEGORICAL[2],
  CHART_CATEGORICAL[4],
  CHART_SUCCESS,
  CHART_CATEGORICAL[0],
] as const;

export const CHART_COST_COLORS = {
  merch: CHART_CATEGORICAL[0],
  genApi: CHART_CATEGORICAL[2],
  gcp: CHART_CATEGORICAL[4],
  taggers: CHART_CATEGORICAL[3],
} as const;

export const CHART_SERVICE_COLORS = {
  merch: CHART_CATEGORICAL[0],
  video: CHART_CATEGORICAL[1],
  interior: CHART_SUCCESS,
  ads: CHART_CATEGORICAL[4],
  mobile: CHART_CATEGORICAL[5],
  genapi: CHART_CATEGORICAL[2],
} as const;

export const CHART_LATENCY_COLORS = {
  p50: CHART_CATEGORICAL[0],
  p75: CHART_CATEGORICAL[1],
  p90: CHART_CATEGORICAL[2],
  queue: CHART_WARNING,
  boot: CHART_ERROR,
  execution: CHART_CATEGORICAL[0],
  total: '#0f766e',
} as const;

export const CHART_RETRY_COLORS = [
  CHART_SUCCESS,
  CHART_WARNING,
  CHART_ORANGE,
  CHART_ERROR,
  CHART_ERROR_DARK,
] as const;

export const CHART_GRID_PROPS = {
  stroke: '#e5ebef',
  strokeDasharray: '3 3',
  vertical: false,
} as const;

export const CHART_AXIS_TICK = {
  fill: '#6b8295',
  fontSize: 10,
} as const;

export const CHART_AXIS_PROPS = {
  axisLine: false,
  tickLine: false,
} as const;

export const CHART_BAR_PROPS = {
  maxBarSize: 18,
} as const;

export const CHART_TOOLTIP_STYLE: CSSProperties = {
  backgroundColor: '#ffffff',
  border: '1px solid #d9e3ea',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(16, 42, 67, 0.12)',
  color: '#33424f',
  fontSize: '12px',
};

export const CHART_TOOLTIP_LABEL_STYLE: CSSProperties = {
  color: '#243746',
  fontWeight: 600,
};

export const CHART_LEGEND_STYLE: CSSProperties = {
  color: '#55697c',
  fontSize: '12px',
};

export const CHART_LABEL_LINE_STYLE = {
  stroke: '#6b8295',
  strokeWidth: 1,
} as const;
